import React, { useCallback, useEffect, useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { TAverageGait } from '../../shared/types/exam.type';
import { isEmpty, reverse } from 'lodash';
import { useAuth } from '../../hooks/useAuth';
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";


function DonutActivityZone({ data, printable, totalDistance, totalTime }: { data?: TAverageGait[], printable?: boolean, totalDistance?: string, totalTime?: string }) {
    const { isUserTypePolo } = useAuth()

    const gallopColors = ["#99141a", '#FF4433']

    const colors = ["#e0e0e0", "#b3a400", "#f7911a", ...(isUserTypePolo ? reverse(gallopColors) : gallopColors)]


    const theme = useTheme()
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const { t } = useTranslation()
    const formatDataPolo = () => {
        if (!isEmpty(data)) {
            console.log({ data });

            return data?.filter(item => item.percentage !== 0).map(item => ({
                name: `${t('intervals:gait:' + item?.gait)} <br>
                    ${item?.speed_formatted} <br>
                    ${item?.average_heart_rate !== 0 ? item?.average_heart_rate + ' ' + t('units:bpm') : ''} <br>
                 ${Math.trunc((item?.time_seconds ?? 0) / 60)} min (${item?.percentage} %)<br>
                   `,
                y: item?.percentage,
                color: colors[item?.gait]
            }))
        }
    }


    const formatDataBasic = () => {
        if (!isEmpty(data)) {
            return data?.filter(item => item.percentage !== 0)
                .map(item => ({
                    name: `${t('intervals:gait:' + item?.gait)} 
                     ( ${item?.percentage} %)  <br>
                 ${Math.trunc((item?.time_seconds ?? 0) / 60)} min ${item?.distance_formatted && ' - ' + item?.distance_formatted} <br>
                  ${item?.speed_formatted} ${item?.average_heart_rate !== 0 ? ' - ' + item?.average_heart_rate + ' Bpm' : ''}`,
                    y: item?.percentage,
                    color: colors[item?.gait]
                }))
        }
    }

    const formatData = () => {
        return isUserTypePolo ? formatDataPolo() : formatDataBasic()
    }

    const options = useMemo(() => {
        if (!isEmpty(data)) {
            return {
                chart: {
                    type: 'pie',
                    backgroundColor: null,
                    plotShadow: false,
                    spacing: [40, 40, 40, 40],
                    margin: [5, 5, 5, 5],
                },
                title: { text: '' },
                credits: { enabled: false },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'default',
                        states: {
                            hover: { enabled: false },
                            inactive: { opacity: 1 },
                        },
                        events: {
                            mouseOver: function (this: Highcharts.Point) {
                                this.setState('');
                            },
                        },
                        dataLabels: {
                            allowOverlap: true,
                            crop: false,
                            overflow: 'allow',
                            useHTML: true,
                            padding: 0,
                            softConnector: false,
                            distance: 30,
                            connectorPadding: 10, // Creates space between the line and the text
                        },
                    },
                    series: {
                        type: 'pie',
                        // Maintain your sizes
                        size: '45%',
                        innerSize: '60%',
                        colorByPoint: true,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true,
                            crop: false,
                            overflow: 'allow',
                            distance: 30,
                            connectorPadding: 10, // Creates space between the line and the text
                            useHTML: true,

                            style: {
                                fontSize: (isUserTypePolo && !isSmallScreen) ? '14px' : '12px',
                                color: printable ? 'black' : 'white',
                                textOutline: 'none',
                            },
                            padding: 0,
                            softConnector: false,
                        }
                    }
                },
                tooltip: {
                    enabled: false,
                    // @ts-ignore
                    formatter: function () {
                        // @ts-ignore
                        return this?.point?.options?.name;
                    }
                },
                series: [{ data: formatData() }],

            };
        }
        return null;
    }, [data, printable, t, isSmallScreen, isUserTypePolo]);
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                key={isSmallScreen ? 'small' : 'large'} // ✅ This forces remount when size category changes
            />
            {(totalDistance || totalTime) && (
                <Box sx={{ textAlign: 'center', mt: 2, color: printable ? 'black' : 'white' }}>
                    <Typography variant="body2">
                        {totalDistance && `${t('distance')}: ${totalDistance}`}
                        {totalDistance && totalTime && ' | '}
                        {totalTime && `${t('blocks:duration')}: ${totalTime}`}
                    </Typography>
                </Box>
            )}
        </div>
    )
}

export default DonutActivityZone